module.exports = __webpack_public_path__ + "img/mendian.b81ddb65.png";